import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
//Import Components
import BonusCalculationLogic from 'components/CampaignModal/BonusCalculationLogic';
// Import Constants
import { l } from 'constants/common';

const CampaignReportBonusCalculationLogic = ({ campaignBonus, bonusInfo, isLoading }) => {
    const { t } = useTranslation();

    return (
        <div className="campaign-report-bonus-calculation-logic">
            <ul className="module-header cr-position-radius p-top s-big">
                <li className="left-content">
                    <div className="left-inner">
                        <div className="module-title ellipsis-text">
                            <div className="crm-statics-segment-data-table-name">{t(l.BonusCalculationLogic)}</div>
                        </div>
                    </div>
                </li>
            </ul>
            <div className="campaign-report-bonus-calculation-logic-content">
                <div className="campaign-report-bonus-calculation-logic-scrollable-container">
                    <BonusCalculationLogic
                        campaignBonus={campaignBonus}
                        bonusInfo={bonusInfo}
                        isLoading={isLoading}
                        isVertical={true}
                    />
                </div>
            </div>
        </div>
    );
};

CampaignReportBonusCalculationLogic.propTypes = {
    campaignBonus: PropTypes.object.isRequired,
    bonusInfo: PropTypes.object.isRequired,
    isLoading: PropTypes.bool.isRequired,
};

export default memo(CampaignReportBonusCalculationLogic);
